import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component

/**
 * StatisticsView class extends JetView to create a custom view for statistics.
 */
export default class StatisticsView extends JetView {
    /**
     * Configures the layout of the StatisticsView.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        return {
            rows: [
                // Main layout structure using rows
                {
                    height: 10, // Spacer row with fixed height
                },
                {
                    type: 'wide', // Defines a wide layout for the next rows
                    rows: [
                        {
                            gravity: 2, // Allows this row to grow and take available space
                            type: 'wide', // Defines a wide layout for the columns
                            cols: [
                                GeoView, // First column with GeoView component
                                {
                                    type: 'wide', // Defines a wide layout for the nested rows
                                    minWidth: 370, // Sets a minimum width for this column
                                    rows: [PositionsView, TagsView], // Nested rows with PositionsView and TagsView components
                                },
                            ],
                        },
                        {
                            type: 'wide', // Defines a wide layout for the next columns
                            cols: [MoneyView, AgeView], // Columns with MoneyView and AgeView components
                        },
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
